import type { CollectionSyncStatus } from "@/types/domain";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface SyncStatusBadgeProps {
  status: CollectionSyncStatus;
  pushed?: number;
  total?: number;
}

const statusConfig: Record<
  CollectionSyncStatus,
  { color: string; label: string }
> = {
  not_synced: { color: "bg-gray-400", label: "Not synced" },
  synced: { color: "bg-green-500", label: "Synced" },
  partially_synced: { color: "bg-amber-500", label: "Partially synced" },
};

export function SyncStatusBadge({ status, pushed, total }: SyncStatusBadgeProps) {
  const config = statusConfig[status];

  const badge = (
    <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
      <span className={`h-2 w-2 rounded-full ${config.color}`} />
      {config.label}
    </span>
  );

  if (pushed !== undefined && total !== undefined) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent>
          {pushed}/{total} locations pushed to production
        </TooltipContent>
      </Tooltip>
    );
  }

  return badge;
}
